(function(){

    angular.module('tmx-app').controller('inboxCtrl', ['$scope','$mdMedia', '$mdDialog', '$state','LoanApplicationService','AccountApplicationService','TradeRepositoryService',
        'lookupService','$mdSidenav','tmxUtility','menu','cacheStore','TMX_FINANCE_CONSTANTS', 


        function InboxCtrl($scope,$mdMedia, $mdDialog, $state, LoanApplicationService,AccountApplicationService,TradeRepositoryService, 
            lookupService,$mdSidenav,tmxUtility,menu,cacheStore,TMX_FINANCE_CONSTANTS){

            var vm=this;
            vm.EntityName = "LoanApplication";
        ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            vm.menu = menu;
            vm.Privileges = [];
            vm.ViewPrivilege = false;
            vm.EditPrivilege = false;
            vm.DeletePrivilege = false;
            vm.AddPrivilege = false;
            vm.AssignPrivilege =false;
            vm.VerifyPrivilege =false;
            vm.ApprovePrivilege =false;
            vm.tenantName ="";
            vm.checkPermission = tmxUtility.checkPermission;
            vm.formatDate = tmxUtility.formatDateForCompany;
            vm.filterChips = [];
            var previousSelectedChip = null;
            vm.go=function(){
                $state.go('frame.loanapplication');
            }
            var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
            vm.loanEditPermission = vm.checkPermission('Private.Transaction.LoanApplication','Edit');
            vm.accountOpeningPermission= vm.checkPermission('Private.Transaction.AccountOpeningApplication','Edit');
            vm.tradePermission = vm.checkPermission('Private.Transaction.TradeRepository','Edit');
            vm.ProceedPrivilege = vm.checkPermission('Inbox Proceed Button','View');

            populateConfigurations();
            vm.tenant= APP_CONSTANTS.tenant;
            
        
            var vitasTenants = ["vitas","vitas-leb","vitas-eg","vitasiraq"];
            var isJordanTenant = vm.tenant.toLowerCase() == TMX_FINANCE_CONSTANTS.TENANTS.VITAS;
            vm.fullNameColumnhide = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true;
            vm.fullNameColumnshow = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false;                       

            function populateConfigurations() {
                var configurations = cacheStore.get("Configurations");
                vm.tenantName = tmxUtility.getConfigurationValue(configurations, 'INTEGRATION_TENANT').toLowerCase();
            }                                 

            var applicationStatusLkps = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.APPLICATION_STATUS).map(x=>({VisibleValue:x.VisibleValue,HiddenValue:x.VisibleValue}));
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            vm.query = "Company";
            var   exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            vm.date = new Date().toJSON();
            vm.lookup=[];
            vm.formatString=function(value){
                if(!value) {
                    return "N/A";
                }
                else {
                    return value;
                }                        
            };

            vm.formatSubtitle=function(value){
                if(!value) {
                    return "";
                }
                else {
                    return value;
                }                        
            };
                  
            vm.nav = "SearchSideNav";
            vm.schema = LoanApplicationService.schema;
            vm.cloneColumn = LoanApplicationService.gridColumn;
            vm.LoanApplicationService = LoanApplicationService;
            vm.getLookupName=LoanApplicationService.getLookupName;

        //*************Functions****************
            vm.reload=function(){
                vm.container.companyGrid.dataSource.read();
            };


            vm.success=function(promise){
                if(promise.read==true) {
                    vm.container.companyGrid.dataSource.transport.read(promise);
                }
                else {
                    vm.container.companyGrid.dataSource.read();
                }
                vm.toggle(vm.nav);
            };
            vm.isFiltered=function(fieldName){
                var filtered = false;
                if(angular.isDefined(vm.filters)) {
                    vm.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            };
            vm.formatCNICNumber = function (dataitem) {
                if (!dataitem) return '';
                return dataitem;
            };

            vm.formatAppAmount = function (dataitem) {
                if (!exists(dataitem)) return 'N/A';
                return dataitem;
            };

            vm.formatTotalTenure = function (dataitem) {
                if (!exists(dataitem)) return 'N/A';
                return dataitem;
            };

            vm.formatCustomerCode = function (custCode) {
                if (!custCode || custCode === "0") return '';
                return custCode;
            };
            vm.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            };

            vm.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            vm.newLoanApplication = function(){
                $state.go("private.transaction.loanapplication.add",{callbackState:"private.inbox"});
            };

            vm.clickEdit = function (item) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyId});
            };


            vm.clickView = function (item) {
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyId});
            };


//*******************Kendo row template functions****************************

            vm.dataObj ={
                value: "empty"};

            vm.isStatusActive=function(dataitem){
                if(dataitem.EffectiveEndDate<vm.date)return true;
                return false;
            };

            vm.status=function(dataitem){
                if(dataitem.EffectiveEndDate<vm.date) {
                    return "Inactive";
                }
                return "Active";
            }

            vm.getCompanyType=function(dataitem){
                if(angular.isDefined(LoanApplicationService.lookup.type) && LoanApplicationService.lookup.type.length>0) {
                    for (var i = LoanApplicationService.lookup.type.length - 1; i >= 0; i--) {
                        if(LoanApplicationService.lookup.type[i].HiddenValue==dataitem.CompanyTypeLkp) {
                            return LoanApplicationService.lookup.type[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            }

            vm.formatCompanyName=function(dataitem) {
                return tmxUtility.sliceText(dataitem.CompanyName,25);
            };

            vm.getCompanyClass=function(dataitem){
                if(angular.isDefined(LoanApplicationService.lookup.classification) && LoanApplicationService.lookup.classification.length>0) {
                    for (var i = LoanApplicationService.lookup.classification.length - 1; i >= 0; i--) {
                        if(LoanApplicationService.lookup.classification[i].HiddenValue==dataitem.CompanyClassificationLkp) {
                            return LoanApplicationService.lookup.classification[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            };

            vm.getContactPerson=function(dataitem){
                if(angular.isDefined(dataitem.TmXCompanyContactPerson) && dataitem.TmXCompanyContactPerson!=null) {
                    if(angular.isDefined(dataitem.TmXCompanyContactPerson.ContactPersonName) && dataitem.TmXCompanyContactPerson.ContactPersonName!=null) {
                        return dataitem.TmXCompanyContactPerson.ContactPersonName;
                    }
                }
                return "N/A";
            };

            vm.formatLoanAmount=function(Amount){
                if(Amount <=0){
                    return "N/A";
                }
                else {
                    return Amount;

                }
            };

            vm.formatDateTime = function(dateObj){
                return tmxUtility.formatDateSpecific(dateObj,"DD/MMM/YYYY hh:mma");
            }

            vm.formatTenure=function(Tenure){
                if(parseInt(Tenure, 10)<=0){
                    return "N/A";
                }
                else {
                    return Tenure;

                }
            };
            vm.getContactPhoneNumber=function(dataitem){

                if(angular.isDefined(dataitem.TmXCompanyContactPerson) && dataitem.TmXCompanyContactPerson!=null) {
                    if(angular.isDefined(dataitem.TmXCompanyContactPerson.PhoneNumber1) && dataitem.TmXCompanyContactPerson.PhoneNumber1!=null) {
                        var country, city, number;

                        country = dataitem.TmXCompanyContactPerson.PhoneNumber1.slice(0,2);
                        city = dataitem.TmXCompanyContactPerson.PhoneNumber1.slice(2,5);
                        number = dataitem.TmXCompanyContactPerson.PhoneNumber1.slice(5);
                        number = number.slice(0, 3) + '-' + number.slice(3,7);
                        return "+"+country+" (" +city+") "+number;

                    }
                }
                return "N/A";
            };
        ///////////////// For Loan Application EDIT ///////////////////
            vm.goToLAEdit=function(id){
             
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.loanapplication.edit",{Id:id,callbackState:$state.current.name});
            };
            vm.goToLAView=function(id){
             
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.loanapplication.edit",{Id:id,callbackState:$state.current.name});
            };
        ///////////////// For Account Opening Application EDIT ///////////////////
            vm.goToAAEdit=function(id){
             
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.accountopeningapplication.edit",{Id:id,callbackState:$state.current.name});
            };
            vm.goToAAView=function(id){
             
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.accountopeningapplication.edit",{Id:id,callbackState:$state.current.name});
            };
            vm.goToTREdit=function(id){
             
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.traderepository.edit",{Id:id,callbackState:$state.current.name});
            };
            vm.goToTRView=function(id){
             
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go("private.transaction.traderepository.edit",{Id:id,callbackState:$state.current.name});
            };         

//*******************KENDO*********************//
            var culture=kendo.culture();

            culture.numberFormat.currency.symbol = "PKR. ";            
        // ng-disabled="!InboxCtrl.EditPrivilege"
            vm.formatApplicationName=function(item){                
                var id=item.ApplicationID;
                var type=item.ApplicationType;             
                var template;                
                if(type==TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.LOANAPPLICATION){
                    template="<md-button ng-disabled='!InboxCtrl.loanEditPermission' class='tmx-primary-text-grid'  ng-click='InboxCtrl.goToLAEdit("+id+")'>"+item.ApplicationNumber+"</md-button> <div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}}> "+item.Status+ "</span> <span class='subtitle' ng-if=\" !(InboxCtrl.tenantName != 'samba' || InboxCtrl.tenantName=='soneri') \"> {{item.CustomerAccountNumber}} </span></div>";
                }
                else if(type==TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.ACCOUNTAPPLICATION){                    
                    template="<md-button ng-disabled='!InboxCtrl.accountOpeningPermission' class='tmx-primary-text-grid'  ng-click='InboxCtrl.goToAAEdit("+id+")'>"+item.ApplicationNumber+"</md-button> <div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}}> "+item.Status+ "</span>  <span class='subtitle' ng-if=\" !(InboxCtrl.tenantName != 'samba' || InboxCtrl.tenantName=='soneri') \"> {{item.CustomerAccountNumber}} </span></div>";
                }
                else if(type==TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.TRADE){                    
                    template="<md-button ng-disabled='!InboxCtrl.tradePermission' class='tmx-primary-text-grid'  ng-click='InboxCtrl.goToTREdit("+id+")'>"+item.ApplicationNumber+"</md-button> <div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}}> "+item.Status+ "</span> <span class='subtitle' ng-if=\" !(InboxCtrl.tenantName != 'samba' || InboxCtrl.tenantName=='soneri') \"> {{item.CustomerAccountNumber}} </span></div>";
                }

                return template;
            };
            vm.makeProcessId=function(item){
                return item.LoanApplicationId+'-'+item.LoanType;
            };

            vm.clickReassignment = function (dataItem,ev) {     
                $mdDialog.show({
                    controller: ReassignDialogController,
                    locals:{dataItem: dataItem},
                    templateUrl: 'app/private/inbox/reassign-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:false,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function(responseArray) {
                        if(responseArray) {
                            LoanApplicationService.reassignApplication(responseArray).then(function() {
                                $('#grid').data('kendoGrid').dataSource.read();
                            });
                                
                        }                
                    }, function() {
                
                    });              
            }   
        

            function ReassignDialogController($scope,dataItem,UsersService) {
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
          
                UsersService.getUserByRole(dataItem.InboxUserRoleId).then(function(response) {
                    $scope.UserList = response.data;

                    $scope.UserList.forEach(function(item) {
                        item.HiddenValue = item.UserID;
                        item.VisibleValue = item.UserName;
                    })
                    
                });
              
                $scope.done = function() {
                    var array = [{
                        InboxUserId:dataItem.InboxUserId,
                        ProcessId : dataItem.ProcessInstanceID,
                        TargetUserId:$scope.TargetUserId
                    }]
                    $mdDialog.hide(array);
                };
            }

            vm.clickProceed = function (dataItem,ev) {     

                var availableStates = [];
                LoanApplicationService.getCommandsByProcessId(dataItem.ProcessId).then(function(response) {
                    if(tmxUtility.exists(response,'data')){
                        availableStates = response.data;
                    }
                    onCommandListResponse();
                });
                function onCommandListResponse(){
                    $mdDialog.show({
                        controller: ['$scope','$mdDialog', 'dataItem','availableStates', ProceedDialogController],
                        locals:{dataItem: dataItem,availableStates:availableStates},
                        templateUrl: 'app/private/inbox/proceed-dialog.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose:false,
                        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                    })
                        .then(function(returnData) {
                            if(tmxUtility.exists(returnData,'Command')) {
                                var targetApiController = '';
                                if(returnData.TransactionType == TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.LOANAPPLICATION){
                                    targetApiController = 'LoanApplication';
                                }
                                else if(returnData.TransactionType == TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.ACCOUNTAPPLICATION){
                                    targetApiController = 'AccountApplication';
                                }
                                else if(returnData.TransactionType == TMX_FINANCE_CONSTANTS.TRANSACTION_TYPES.TRADE){
                                    targetApiController = 'Transaction';
                                }
                                LoanApplicationService.executeTransactionWF(targetApiController,returnData).then(function() {
                                    $('#grid').data('kendoGrid').dataSource.read();
                                });
                                
                            }                
                        }, function() {
                
                        });              
                }   
            }
            
            function ProceedDialogController($scope,$mdDialog,dataItem,availableStates){
                $scope.AvailableStates = availableStates;
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
          
                $scope.done = function() {
                    var command = {
                        ApplicationId:dataItem.ApplicationID,
                        UserId:dataItem.InboxUserId,
                        ProcessId : dataItem.ProcessInstanceID,
                        Command:$scope.TargetState,
                        TransactionType:dataItem.ApplicationType
                    };
                    $mdDialog.hide(command);
                };
            }

            vm.gridColumns = [
                {
                    field:"ApplicationNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    template:vm.formatApplicationName,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ApplicationNumber')}\" >{{'Application' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"ApplicationNumber\")' ></i></span>"

                },
                {
                    field:"ClientReferenceNumber",
                    title: "TransactionID",
                    type: "text",
                    search:(vm.tenantName!='soneri' && vm.tenantName!=TenantsList.BOP)?false:true,
                    hidden:(vm.tenantName!='soneri' && vm.tenantName!=TenantsList.BOP)?true:false,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ClientReferenceNumber')}\" >{{'TransactionID' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>"
                },
                {
                    field:"FullName",
                    title: "Customer",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    template: " <div>{{dataItem.FullName | defaultValue}}</div> <span class='subtitle-text'> {{dataItem.NationalIdentifierValue | cnic}}</span> <span class='subtitle' ng-if=\" !(InboxCtrl.tenantName != 'samba' || InboxCtrl.tenantName=='soneri') \"> {{dataItem.CustomerCode}} </span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('FullName')}\" >{{'Customer' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"FullName\")' ></i></span>",
                    hidden:vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    usePattern:false,                    
                },
                {
                    field:"CustomerName",
                    title: "Customer",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    template: "<div> {{dataItem.CustomerName | defaultValue}}</div> <span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span> <span class='subtitle' ng-if=\" !(InboxCtrl.tenantName != 'samba' || InboxCtrl.tenantName=='soneri') \"> {{dataItem.CustomerCode}} </span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    hidden: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    usePattern:false
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Cnic",
                    type: "numeric",
                    search: vm.tenantName!=TenantsList.BOP?true:false,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    template: "<span class='nowrap'>{{dataItem.NationalIdentifierValue | cnic}}</span>"

                },
                {
                    field:"ProductName",
                    title:"Product",
                    type: "text",
                    search: true,                    
                    template:"<span style='max-width:15pt;' title='{{dataItem.ProductName}}'>{{ dataItem.ProductName }}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"ApprovedAmount",
                    title:"ApvAmount",
                    type: "integer",
                    hidden: vm.tenantName == "samba" || vm.tenantName=="soneri"? true : false,
                    search: vm.tenantName == "samba" || vm.tenantName=="soneri"? false : true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ApprovedAmount')}\" >{{'ApvAmount' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"ApprovedAmount\")' ></i></span>"
                },
                // {
                //     field:"TotalTenure",
                //     title:"LoanTenure",
                //     type: "integer",
                //     search: vm.tenantName == "samba" || vm.tenantName=="soneri"? false : true,
                //     hidden: vm.tenantName == "samba" || vm.tenantName=="soneri"? true : false,
                //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('TotalTenure')}\" >{{'LoanTenure' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"TotalTenure\")' ></i></span>"

                // },
                {
                    field:"CustomerCode",
                    title:"CIFNumber",
                    type: "integer",
                    hidden:true,
                    search: vm.tenantName != "samba" || vm.tenantName=="soneri"? false : true,                    
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('CustomerCode')}\" >{{'CIFNumber' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"CustomerCode\")' ></i></span>"
                },
                {
                    field:"CustomerAccountNumber",
                    title:"AccountNo",
                    type: "integer",
                    search: vm.tenantName != "samba" || vm.tenantName=="soneri"? false : true,
                    hidden:true,                    
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('CustomerAccountNumber')}\" >{{'AccountNo' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"CustomerAccountNumber\")' ></i></span>"

                },
                {
                    field:"BranchName",
                    title:"BranchName",
                    type: "alpha",
                    search: vm.tenantName!=TenantsList.BOP?true:false,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('BranchName')}\" >{{'Branch' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"CreatorName",
                    title:"Creator",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',                         
                    template:"<div>{{dataItem.CreatorName}}</div><span class='subtitle-wrap '>{{ dataItem.Creator }}</span>",   
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('CreatorName')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"CreatorName\")' ></i></span>"
                },
                {
                    field:"InboxName",
                    title:"Assigned To",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"InboxUser\")' ></i></span>",
                    template:"<div>{{dataItem.InboxName}}</div><span class='subtitle-wrap '>{{ dataItem.InboxUser }}</span><br><span ng-if='dataItem.InboxName!=null' class='subtitle-wrap'><b>{{ dataItem.TransitionTime }}</b></span>", 
                },   
                {
                    field:"LoanAssignedCredit",
                    title:"Loan Credit",
                    type: "text",
                    search: true,  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('LoanAssignedCredit')}\" >{{'LoanAssignedCredit' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanAssignedCredit\")' ></i></span>",
                },
                {
                    field:"ApplicationDate",
                    title:"AppDate",
                    type: "date",
                    search: true,                   
                    template: "<span>{{dataItem.FormattedApplicationDate}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ApplicationDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"LoanApplicationDate\")' ></i></span>"
                }, 
                {
                    field:"LastUpdatedDate",
                    title:"Updated Date",                    
                    type: "date",
                    search: true,                    
                    format: "{0:dd MMM yyyy}",
                    hidden: !isJordanTenant,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('LastUpdatedDate')}\" >{{'Updated Date' | translate}}<i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"LastUpdatedDate\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "select",
                    hidden:true,
                    data: applicationStatusLkps,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('Status')}\" >{{'Status' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"Status\")' ></i></span>"
                },
                {
                    template: "<md-menu flex='none' class='menu-list-item' md-offset='-20 60'>"+
                "<md-button class='menu-list-item-grid' ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>"+
                "<md-menu-content width='2'>"+
                "<md-menu-item><md-button  aria-label='edit' class='tmxMin' ng-disabled='!InboxCtrl.ProceedPrivilege' ng-click='InboxCtrl.clickProceed(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>arrow_forward</md-icon>Proceed</md-button></md-menu-item>"+
                "<md-menu-item><md-button  aria-label='edit' class='tmxMin' ng-disabled='!InboxCtrl.DeletePrivilege' ng-click='InboxCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Cancel</md-button></md-menu-item>"+                
                "<md-menu-item><md-button  aria-label='edit' class='tmxMin' ng-disabled='!InboxCtrl.AssignPrivilege' ng-click='InboxCtrl.clickReassignment(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>done</md-icon>Reassign</md-button></md-menu-item>"+                
                "</md-menu-content></md-menu>"
                }
            ];
        
            vm.checkDeletePermission = function(item) {
                if (JSON.parse(localStorage.getItem("user")) && item.CreatorId == JSON.parse(localStorage.getItem("user")).Id) {
                    return false;
                }
                else {
                    return true;
                }            
            }
            vm.checkEntityPermission = function(privilegeName) {
                return vm.checkPermission('Private.Inbox',privilegeName);
            }

            vm.clickDelete = function(item) {
                deleteConfirm(item);
            };

            var deleteConfirm = function(item, ev) {
                var confirm = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .title('Cancel Application ' + item.ApplicationNumber + " ?")
                    .textContent('Are you sure you want to cancel this Application?')
                    .ariaLabel('Lucky day')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    deleteApplication(item);
                });
            };

            var deleteApplication = function(item) {
                if(item.ApplicationType == "LoanApplication") {
                    LoanApplicationService.CancelById(item.ApplicationID).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
                else if(item.ApplicationType == "AccountApplication") {
                    AccountApplicationService.CancelById(item.ApplicationID).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
                else if(item.ApplicationType == "TradeRepository") {
                    TradeRepositoryService.CancelById(item.ApplicationID).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
            };


            vm.filters = {};
            vm.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o){
                            if(angular.isDefined(vm.searchClear) && vm.searchClear==false){
                                if(exists(vm.o)){
                                    copy(vm.o.data,["filter"],o.data);
                                }
                            }
                            vm.searchClear = false;
                            if(vm.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    vm.searchClear = true;
                                    $state.searchClear=undefined;
                                //return;
                                }
                            //if(exists(vm.o))
                            //    copy(vm.o.data,["filter"],o.data);
                            }
                            else
                                o.data.firstPage = true;

                            vm.o = angular.copy(o);
                            vm.filters = vm.o.data.filter;
                        // LoanApplicationService.getByAction("",true).then(function(response){
                            LoanApplicationService.getByParams(o,true,"/ApplicationInbox").then(function(response){
                                parseResppnse(response.data);
                                vm.excelData=response;
                                o.success(response);

                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },

                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort:  [{field: "LastUpdatedDate", dir: "desc"}]
                },
                excelExport: function(e) {                                         
                    var sheet = e.workbook.sheets[0];
                    var data = vm.excelData.data;
                    var gridColumns = vm.container.companyGrid.columns;                                      
                    var filteredColumns=filterColumns(gridColumns);
                    var columns = tmxUtility.columnsMapping(filteredColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                                                             
                    sheet.rows = rows;  
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "LoanApplications.pdf"
                },
                excel: {
/*
                allPages: true,
*/
                    fileName: "LoanApplications.xlsx"
                },

                sortable: true,
                scrollable: false,
                columns: vm.gridColumns,
                
            };
        //////////INITIALIZING THE $state.data for access to grid in Edit.js///////////////////////////////////////////////
            vm.container = {};//defining the object for grid access in controller
            $state.data= {
                grid: vm.container,
                mainGridOptions: angular.copy(vm.mainGridOptions)
            };
        /*
         vm.container = {};
         $state.data={
         grid: vm.container,
         info: false
         };
         */


            function parseResppnse(data){
                data.forEach(function(dataItem){                                                        
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status); 
                    dataItem.CustomerAccountNumber=vm.formatSubtitle(dataItem.CustomerAccountNumber);   
                    dataItem.NationalIdentifierValue=vm.formatCNICNumber(dataItem.NationalIdentifierValue);   
                    dataItem.CustomerCode =vm.formatCustomerCode(dataItem.CustomerCode);
                    dataItem.deletePermission=vm.checkDeletePermission(dataItem);
                    dataItem.FormattedApplicationDate= vm.formatDate(dataItem.ApplicationDate);
                    dataItem.CreatorName=vm.formatUser(dataItem.CreatorName);
                    dataItem.InboxName=vm.formatUser(dataItem.InboxName);
                    dataItem.TransitionTime = vm.calculateTimeZone(dataItem.TransitionTime);
                });
                              
                vm.AssignPrivilege = vm.checkEntityPermission("Assign");  
                vm.DeletePrivilege = vm.checkEntityPermission("Delete");               
            }

            vm.searchSideNavActive=false;

            vm.toggleSearch=function(){
                if(vm.searchSideNavActive) {
                    vm.searchData = {};
                    vm.searchSideNavActive=false;
                }
                else
                    vm.searchSideNavActive=true;
                vm.toggle('SearchSideNav');
            }
            vm.exportSideNavActive=false;

            vm.toggleExport=function(){
                if(vm.exportSideNavActive)
                    vm.exportSideNavActive=false;
                else
                    vm.exportSideNavActive=true;
                vm.toggle('ExportSideNav');
            }

            vm.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            vm.filt = {};


            vm.search = function(navID) {

                let calls=[];


                for (var key in vm.searchData) {
                    if (vm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: vm.searchData[key]
                        });
                    }
                }

                vm.filt = {
                    filters: calls,
                    logic: "and"
                };
                vm.o.data.filter = vm.filt;
                vm.container.companyGrid.dataSource.transport.read(vm.o);

                vm.searchData = {};
                vm.toggle(navID);
            };

            vm.clear = function(navID) {
                vm.searchData = {};
                vm.toggle(navID);
            };


            function filterColumns(gridColumns){
                var columns=[];                
                gridColumns.map(function(col){
                    if(col.field=="ClientReferenceNumber"){     
                        if(vm.tenantName=="soneri" || vm.tenantName==TenantsList.BOP)                                      
                            columns.push(col);                        
                    }
                    else if(col.field=="CustomerCode" || col.field=="CustomerAccountNumber"){
                        if(!(vm.tenantName != 'samba' || vm.tenantName=='soneri'))                       
                            columns.push(col);                        
                    }                      
                    else if(col.field=="LastUpdatedDate"){
                        if(isJordanTenant)                                                
                            columns.push(col);                        
                    }
                    else if(col.field=="ApprovedAmount" || col.field=="TotalTenure"){                                                    
                        if ((vm.tenantName != 'samba' || vm.tenantName != 'soneri'))
                            columns.push(col);                        
                    }
                    else if(col.field=="FullName"){                                              
                        if(vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1)
                            columns.push(col);                        
                    }
                    else if(col.field=="CustomerName"){                                                
                        if(!(vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1))
                            columns.push(col);                        
                    }                                          
                    else{                       
                        columns.push(col);
                    }
                });
                return columns;
            }

            function PrepareFilterChips(){
                let roleStatusLookups = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ROLE_STATUS_MAPPING);
                let loggedinUserInfo = cacheStore.get('GetInfoOfLoggedInUser');
                if(!exists(loggedinUserInfo)){
                    return;
                }
                let roleStatusMappingItem = roleStatusLookups.find(x=>x.HiddenValue.toLowerCase() == loggedinUserInfo.RoleName.toLowerCase());
                if(!exists(roleStatusMappingItem)){
                    return;
                }          
                vm.filterChips = roleStatusMappingItem.Description.split(',').map(x=>({Name:x.trim(),Style:'default'}));
                if(vm.filterChips.length > 0){
                    vm.filterChips.unshift({Name:'All',Style:'active'}); // Add 'All' on the begining of the array
                    previousSelectedChip = 'All';
                }
            }

            vm.calculateTimeZone=function(time){
                if(!time) return "";
                var t = new Date().getTimezoneOffset();
                var onlyTime = time.split('T');
                var hours = onlyTime[1].split(':');
                var h = t / 60;
                var calculatedTime = hours[0] - h;
                var ampm = calculatedTime >= 12 ? 'PM' : 'AM';
                if(calculatedTime > 12){
                    calculatedTime=calculatedTime%12;
                }
                var splitDate = onlyTime[0].split('-');
                var mon = splitDate[1];
                var month = "";
                switch (mon) {
                case '01':
                    month = "Jan";
                    break;
                case '02':
                    month = "Feb";
                    break;
                case '03':
                    month = "Mar";
                    break;
                case '04':
                    month = "April";
                    break;
                case '05':
                    month = "May";
                    break;
                case '06':
                    month = "June";
                    break;
                case '07':
                    month = "July";
                    break;
                case '08':
                    month = "Aug";
                    break;
                case '09':
                    month = "Sept";
                    break;
                case '10':
                    month = "Oct";
                    break;
                case '11':
                    month = "Nov";
                    break;
                case '12':
                    month = "Dec";
                    break;
                }
                t= splitDate[2] + "/" + month + "/" + splitDate[0] + " " + calculatedTime +":"+ + hours[1] + " "+ ampm;

                return t;
            };

            vm.formatUser=function(value){
                if(!value) {
                    return " ";
                }
                else {
                    return value;
                }                        
            };
            vm.onChipClick = function(selectedChip){
                if(previousSelectedChip == selectedChip.Name){
                    return;
                }
                previousSelectedChip = selectedChip.Name;
                vm.filterChips.forEach(x=>x.Style ='default');
                selectedChip.Style = 'active';

                if(exists(vm.o.data.filter)){
                    // If there is previous filter applied then remove the 'Status' Filter
                    vm.o.data.filter.filters =vm.o.data.filter.filters.filter(x=>x.field != 'Status');
                }
                else {
                    //Initialize the filters
                    vm.o.data.filter = {
                        filters:[],
                        logic:'and'
                    }
                }
                if(selectedChip.Name.toLowerCase() != 'all'){
                    var chipFilter = {
                        field:'Status',
                        operator:'contains',
                        value:selectedChip.Name
                    }
                    vm.o.data.filter.filters.push(chipFilter);
                }
                vm.container.companyGrid.dataSource.transport.read(vm.o);
            };

            (function Initialize(){
                PrepareFilterChips();
            })();

        }]);

})();
